module.exports = __webpack_public_path__ + "f15959614118022a53612d812d7a14ea.webp";